import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/core/service/auth.service';
import { CallApiService } from 'src/app/core/service/call-api.service';
import { GlobalService } from 'src/services/global.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class DoctorService {

	data = new FormData();
	constructor(
		private callAPI: CallApiService,
		private global: GlobalService,
		private router: Router,
		private authService: AuthService,
		private translate: TranslateService,
		private http: HttpClient
	) { }
	// Http Options
	httpOptions = {
		headers: new HttpHeaders({
			'Authorization': `Bearer ${localStorage.getItem('authentication_token')}`,
			'Accept-Language': localStorage.getItem('lang') ? localStorage.getItem('lang')! : 'en'
		})
	}

	// Profile Section Start here ##############################################
	// Get Profile
	get_doctor_profile(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		// if (this.authService.currentUserValue.user_role == 'Doctor') {
		// 	data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
		// 	console.log('user_role', this.authService.currentUserValue.user_role)
		// } else if (this.authService.currentUserValue.user_role == 'doctor') {
		// 	data.append('user_role', this.authService.currentUserValue.user_role);
		// 	console.log('user_role', this.authService.currentUserValue.user_role);
		// }
		return this.callAPI._postAPI('/doctor/profile', data, this.httpOptions)
	}
	// Update Doctor Profile
	updateProfile(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/profile-update', data, this.httpOptions)
	}
	// Profile Section END here ###############################################
	// Get and set Service
	doctor_service(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/doctor-services', data, this.httpOptions)
	}
	// Update Service Profile
	update_doctor_service(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/doctor-update-services', data, this.httpOptions)
	}
	// Get and set service at
	doctor_service_at(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/doctor-services-at', data, this.httpOptions)
	}
	update_service_at(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/doctor-update-servicesAt', data, this.httpOptions)
	}

	// doctor specialty
	doctor_specification(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/doctor-specialities', data, this.httpOptions)
	}
	// update specification
	update_doctor_specification(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/doctor-update-specialities', data, this.httpOptions)
	}


	// Change Availibility
	update_doctor_availability(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/change-availabilies', data, this.httpOptions)
	}
	// Profile Section END here ##################################################

	// Appointment Section START here ############################################
	doctor_upcoming_appointment_list(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		//data.append('page_no', '1');
		return this.callAPI._postAPI('/doctor/upcoming-appointments', data, this.httpOptions)
	}
	doctor_past_appointment_list(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		//data.append('page_no', '1');
		return this.callAPI._postAPI('/doctor/past-appointments', data, this.httpOptions)
	}
	doctor_past_appointment_detail(data) {
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/appointment-detail', data, this.httpOptions)
	}
	doctor_appointment_complete(data) {
		data.append('user_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
		return this.callAPI._postAPI('/doctor/complete-appointment', data, this.httpOptions)
	}
	doctor_appointment_reschedule(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/reschedule-appointment', data, this.httpOptions)
	}
	// Appointment Section END here ############################################

	// Chat Section START here #################################################
	// Appointment Detail
	doctor_appointment_details(data) {
		// data.append('appointment_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/appointment-detail', data, this.httpOptions)
	}
	doctor_appointment_message_list(data) {
		data.append('language', this.translate.currentLang);
		// data.append('page_no', "1");
		return this.callAPI._postAPI('/patient/appointment-chat', data, this.httpOptions)
	}
	send_doctor_chat_appointment(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		// data.append('page_no', "1");
		return this.callAPI._postAPI('/patient/send-chat', data, this.httpOptions)
	}

	// Chat Section END here ###################################################

	// Reviews Section START here ##############################################
	all_reviews(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/over-all-rating-reviews', data, this.httpOptions)
	}
	//review detail and star rating
	doctor_review_detail(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/rating-reviews-info', data, this.httpOptions)
	}
	// Reviews Section END here ################################################

	// Transactions START here #################################################
	//Current balance
	current_balance(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/current-balance', data, this.httpOptions)
	}
	//Transaction History
	transaction_history(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/wallet-transactions', data, this.httpOptions)
	}
	// Add Money to wallet
	add_money_to_wallet(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/add-to-wallet', data, this.httpOptions)
	}
	// Transactions END here ###################################################

	// Banner list
	// Add banner List
	GetBannerList(data) {
		data.append('user_id', this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.role);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/patient/get-all-active-banners', data, this.httpOptions)
	}

	// Appointment cancel
	// Active/In-active/delete Offer
	appointment_cancel(data) {
		data.append('user_id', this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/cancel-appointment', data, this.httpOptions)
	}
	// send access request
	send_access_request(data) {
		data.append('user_id', this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.role);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/emr/send-emr-access-request', data, this.httpOptions)
	}

	// Doctor Send Money request to withdrawal API
	request_send(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/send-withdrawal-request', data, this.httpOptions)
	}

	//Transaction History
	withdrawal_transaction_history(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/doctor/withdrawal-transactions", data, this.httpOptions);
	}

	// My Address List API
	my_address_list(data) {
		data.append('user_id', this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.role);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/patient/get-all-addresses', data, this.httpOptions)
	}



	// Add My Address
	add_address(data) {
		data.append('user_id', this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.role);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/patient/add-new-address', data, this.httpOptions)
	}
	// Set as default Address
	set_as_address(data) {
		data.append('user_id', this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.role);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/patient/make-default', data, this.httpOptions)
	}
	// Get default Address
	get_default_address(data) {
		data.append('user_id', this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.role);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/patient/get-default-address', data, this.httpOptions)
	}
	// Delete My Address
	delete_address(data) {
		data.append('user_id', this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.role);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/patient/delete-address', data, this.httpOptions)
	}
	// Get Address by ID
	get_address_by_id(data) {
		data.append('user_id', this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.role);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/patient/get-address', data, this.httpOptions)
	}
	// Edit My Address
	edit_address(data) {
		data.append('user_id', this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.role);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/patient/update-address', data, this.httpOptions)
	}
	// Term & Condition
	terms_and_condition(data) {
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/admin/get-term-condition-content", data, this.httpOptions);
	}
	//Contact Us
	contact_us(data) {
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/admin/send-support-email', data, this.httpOptions)
	}
	//Notifiction Api
	doctor_notification(data) {
		data.append('receiver_id', this.authService.currentUserValue.id);
		data.append('receiver_type', this.authService.currentUserValue.user_role.toLowerCase());
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/admin/get-all-notifications', data, this.httpOptions)
	}
	// Prescription  Start here #################################################
	add_prescription(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/doctor/add-prescription-info", data, this.httpOptions);
	}
	// View Prescription
	viewPrescription(data) {
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/doctor/get-prescription', data, this.httpOptions)
	}
	// Edit Prescription
	editPrescription(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/doctor/edit-prescription-info", data, this.httpOptions);

	}
	// Add Medicine
	addmedicine(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/doctor/add-prescription-medicine", data, this.httpOptions);

	}
	// Remove Medicine
	removemedicine(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/doctor/remove-prescription-medicine", data, this.httpOptions);

	}
	//Clinic Details
	add_clinic(data) {
		data.append("login_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());

		return this.callAPI._postAPI("/doctor/add-clinic-details", data, this.httpOptions);
	}
	//get Details
	get_clinic(data) {
		data.append("login_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
		// if (this.authService.currentUserValue.user_role == 'Doctor') {

		// 	// console.log('user_role', this.authService.currentUserValue.user_role)
		// } else if (this.authService.currentUserValue.user_role == 'doctor') {
		// 	data.append('user_role', this.authService.currentUserValue.user_role);
		// 	console.log('user_role', this.authService.currentUserValue.user_role);
		// }
		return this.callAPI._postAPI("/doctor/get-clinic-info", data, this.httpOptions);
	}
	//Update Details
	update_clinic(data) {
		data.append("login_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
		return this.callAPI._postAPI("/doctor/update-clinic-details", data, this.httpOptions);
	}
	//Promocode Offer List
	get_offer(data) {
		data.append("user_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI("/patient/active-offers", data, this.httpOptions);
	}
	//Promocode Offer List
	valid_promocode(data) {
		data.append("user_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI("/patient/promocode-validation", data, this.httpOptions);
	}
	// Platform Setting
	platform_setting(data) {
		data.append("user_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI("/patient/get-platform-settings", data, this.httpOptions);
	}
	// Doctor My order
	upcoming_order(data) {
		data.append("user_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
		return this.callAPI._postAPI("/patient/medicine-upcoming-orders", data, this.httpOptions);
	}
	past_order(data) {
		data.append("user_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
		return this.callAPI._postAPI("/patient/medicine-delivered-orders", data, this.httpOptions);
	}
	//Download Order Invoice
	download_order_invoice(data) {
		data.append("login_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
		return this.callAPI._postAPI("/patient/download-order-invoice", data, this.httpOptions);
	}
	order_invoice(data) {
		data.append("login_id", this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/view-order-invoice", data, this.httpOptions);
	}
	get_order_info(data) {
		data.append("user_id", this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/patient/get-order-info", data, this.httpOptions);
	}
	get_medicine_list(data) {
		data.append("user_id", this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/patient/get-order-medicine-list", data, this.httpOptions);
	}
	send_feedback_medicine(data) {
		data.append("user_id", this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/patient/send-medicine-review-rating", data, this.httpOptions);
	}
	creat_order(data) {
		data.append("customer_id", this.authService.currentUserValue.id);
		data.append('order_by', this.authService.currentUserValue.user_role.toLowerCase());
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/patient/create-order", data, this.httpOptions);
	}
	// Twillio Tocken
	generateSignature(data) {
		data.append("user_id", this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.role);
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/room-access-token", data, this.httpOptions);
	}
	// Qr Code Scanner
	order_scanner(data) {
		data.append("login_id", this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.role);
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/scan-order-invoice", data, this.httpOptions);
	}
	// Order track
	track_order(data) {
		data.append("user_id", this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/patient/track-order", data, this.httpOptions);
	}
	//  Wave Money
	creatr_order(data) {
		data.append("user_id", this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.role);
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/wave-create-payment-session", data, this.httpOptions);
	}
	//  Wave Money
	success_order(data) {
		data.append("user_id", this.authService.currentUserValue.id);
		data.append('user_role', this.authService.currentUserValue.role);
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/wave-get-payment-status", data, this.httpOptions);
	}
	// MTN Payment Status
	mtn_check_payment_status(data) {
		data.append("language", this.translate.currentLang);
		return this.callAPI._postAPI("/mtn-check-payment-status", data, this.httpOptions);
	}
	// Medical file
	// Add Medical file
	add_file(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI("/doctor/add-patient-medical-file", data, this.httpOptions);
	}
	update_file(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI("/doctor/update-patient-medical-file", data, this.httpOptions);
	}
	get_file(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI("/doctor/get-patient-medical-file", data, this.httpOptions);
	}
	list_vaccine(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI("/doctor/get-vaccines", data, this.httpOptions);
	}
	list_disease(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI("/doctor/get-diseases", data, this.httpOptions);
	}
	list_surgery(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI("/doctor/get-surgeries", data, this.httpOptions);
	}
	getProfile(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/patient/profile', data, this.httpOptions)
	}
	getPatientMedicalfile(data) {
		data.append('doctor_id', this.authService.currentUserValue.id);
		data.append('language', this.translate.currentLang);
		return this.callAPI._postAPI('/patient/get-patient-medical-file', data, this.httpOptions)
	}
	get_habbit(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		// data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI('/patient/get-life-habit', data, this.httpOptions)
	}
	get_vaccine(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		// data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI('/doctor/get-vaccines', data, this.httpOptions)
	}
	get_disease(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		// data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI('/doctor/get-diseases', data, this.httpOptions)
	}
	get_medicalbackground(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		// data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI('/doctor/get-surgeries', data, this.httpOptions)
	}
	create_medical_file(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		// data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI('/doctor/add-patient-medical-file', data, this.httpOptions)
	}
	get_medical_file(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		// data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI('/doctor/get-patient-medical-file', data, this.httpOptions)
	}
	doctor_validate_profile(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		// data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI('/doctor/validate-profile', data, this.httpOptions)
	}
	doctor_cosultation_fee(data) {
		data.append("doctor_id", this.authService.currentUserValue.id);
		data.append("language", this.translate.currentLang);
		// data.append('user_role', this.authService.currentUserValue.role);
		return this.callAPI._postAPI('/doctor/appointment-price-update', data, this.httpOptions)
	}
	faqs(data) {
		data.append("admin_id", '1');
		data.append("language", this.translate.currentLang);
		data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
		return this.callAPI._postAPI('/admin/get-faqs-content', data, this.httpOptions);
	}
}
